<template>
<div>
  <router-link :to="{ name: 'userinfo'}">
    <div class="header">
      <div class="user-header">
        <img width="100" height="100" :src="headimgurl" /><!--@/assets/images/avatar.png-->
      </div>
      <div class="user-info">
        <p class="user-name">{{username}}</p>
        <p class="mobile">{{mobile}}</p>
      </div>
      <div class="update-info">
        修改信息
      </div>
    </div>
  </router-link>
</div>
</template>

<script>
export default {
  data() {
    return {
      username: this.$store.state.wx_info.username?this.$store.state.wx_info.username:this.$store.state.wx_info.nickname,
      mobile: this.$store.state.wx_info.mobile,
      headimgurl: this.$store.state.wx_info.headimgurl?this.$store.state.wx_info.headimgurl:require("@/assets/user-avatar.png"),
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
    border: 1px solid #ececec;
    background: #fff;
    height: 7.25rem;
    position: relative;
    box-sizing: border-box;
    width: 100%;
    padding-top: .625rem;
    padding-left: 1rem;
    .user-header {
        //display: inline-block;
        float: left;
        overflow: hidden;
        img {
            border-radius: 50%;
            width: 5.625rem;
            height: 5.625rem;
            border: 1px solid #ececec;
        }
    }
    .user-info {
        position: relative;
        display: inline-block;
        padding-left: 1rem;
        //padding-top: 0.11rem;
        color: #BEC7D1;
        p {
            text-align: left;
            font-size: 1rem;
            line-height: 1.5;
        }
        .user-name {
            font-size: 1.25rem;
            font-weight: bold;
            color: #101010;
        }
    }

    .update-info{
      position: absolute;
      top: .625rem;
      right: 1rem;
      color: #315efb;
      font-size: 0.875rem;
    }
}
</style>
